<template>
  <div>
    <v-form class="container p-5 " ref="form" v-model="valid" lazy-validation>
      <h5><b>Plan </b></h5>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.identity.planCode"
            :rules="planCodeRules"
            label="Plan Code"
            required
          ></v-text-field>
          <v-select
            :items="region"
            required
            :rules="[(v) => !!v || 'Select A Region']"
            label="Select a Region"
            v-model="form.identity.region"
          ></v-select>
          <v-select
            :items="planType"
            required
            v-model="form.planType"
            :rules="[(v) => !!v || 'Select Plan Type']"
            label="Select Plan Type"
          ></v-select>
          <v-text-field
            v-model="form.packageCode"
            label="Package Code"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.tariff"
            type="number"
            :rules="tariffRules"
            label="Tariff"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.imageUrl"
            :rules="imageUrlRules"
            label="Image URL"
            required
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            v-model="form.planName"
            :rules="nameRules"
            label="Plan Name"
            required
          ></v-text-field>
          <v-select
            :items="planFilter"
            required
            v-model="form.planFilter"
            label="Applicable"
          ></v-select>
          <v-select
            :items="category"
            required
            :rules="[(v) => !!v || 'Select A Plan category']"
            v-model="form.category"
            label="Plan Category"
          ></v-select>
          <v-text-field
            v-model="form.channelCount"
            :rules="channelCountRules"
            type="number"
            label="Channel Count"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.serviceCode"
            label="Service Code"
            :rules="serviceCodeRules"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-btn :disabled="!valid" class="primary mr-4" @click="handleSubmit"
        >Submit</v-btn
      >
    </v-form>
  </div>
</template>
<script>
import { extractError } from "../../utils/error";
import { planmaster } from "@/services/planmaster";
export default {
  data: () => ({
    form: {
      identity: {
        region: "",
        planCode: "",
      },
      planName: "",
      description: "",
      planType: "",
      tariffPeriod: 1,
      tariff: "",
      tariffPeriodType: "M",
      packageCode: "",
      hardware: "ALL",
      currency: "INR",
      billFrequency: 1,
      channelCount: "",
      serviceCode: "",
      valid: true,
      customerType: "NORMAL",
      planFilter: true,
      name: "",
      category: "",
      imageUrl: "",
      ncfPrice: 0.0,
      status: 1,
      gst: 18,
      lcoCommission: 0,
    },
    planType: ["PACKAGE", "CHANNEL"],
    planFilter: [{ text: "FR", value: false }, { text: "DP", value: true }],
    region: [
      "PRCKOLHAPUR",
      "PRCKOLHAPURDAS4",
      "PRCSATARADAS3",
      "PRCSATARADAS4",
    ],
    category: ["ALC", "BQ", "BRI", "BST"],
    planCodeRules: [(v) => !!v || "Plan Code Value Required"],
    serviceCodeRules: [(v) => !!v || "Service Code Value Required"],
    nameRules: [(v) => !!v || "Name is required"],
    descriptionRules: [(v) => !!v || "description is required"],
    imageUrlRules: [(v) => !!v || "Image URL is required"],
    packageCodeRules: [(v) => !!v || "Package Code Value required"],
    tariffRules: [(v) => !!v || "Enter Tarrif"],
    channelCountRules: [(v) => !!v || "Channel Count Value Required"],
    valid: true,
    select: null,
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    async handleSubmit() {
      try {
        const hasError = this.validate();
        if (hasError) {
          this.$toasted.error(hasError, {
            duration: 2000,
          });
          return;
        }
        this.form.serviceCode = '["' + this.form.serviceCode + '"]';
        const { form, ...payload } = this.form;
        const result = await planmaster(payload);
        const {
          response: { userID: userId },
        } = result;
        payload[form] = true;
        this.$router.push({
          name: "Planmasterlist",
          // params: {
          //   userId,
          // },
        });
        this.$toasted.success("Successfully created", {
          duration: 2000,
        });
      } catch (err) {
        const message = extractError(err);
        this.$showError(message);
      }
    },
  },
};
</script>
<style scoped>
/* .forum{
    margin-left:3 rem !important;
} */
</style>
